"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAppProtocolUnitKey = exports.getAppProtocolColKey = exports.getAppProtocolAlias = exports.getAllDimensionKeys = exports.assignDimensionToDirection = void 0;
exports.getInverseAndDirection = getInverseAndDirection;
exports.getSingleDirectionDimensionKeys = void 0;
var _customDimensionConstants = require("@kentik/ui-shared/dictionary/v2/compilers/customDimensionConstants");
const getSingleDirectionDimensionKeys = dim => [dim.src, dim.dst, dim.other].filter(k => !!k);
exports.getSingleDirectionDimensionKeys = getSingleDirectionDimensionKeys;
const getAllDimensionKeys = dim => [dim.src, dim.dst, dim.other, dim.bi].filter(k => !!k);
exports.getAllDimensionKeys = getAllDimensionKeys;
const getAppProtocolColKey = ({
  app_protocol
}, {
  custom_column
}) => `ktappprotocol__${app_protocol}__${custom_column}`;
exports.getAppProtocolColKey = getAppProtocolColKey;
const getAppProtocolUnitKey = (appProtocol, column) => {
  const colKey = getAppProtocolColKey(appProtocol, column);
  return column.metadata.hll ? `unique_${colKey}` : colKey;
};
exports.getAppProtocolUnitKey = getAppProtocolUnitKey;
const getAppProtocolAlias = column => {
  const {
    custom_column,
    metadata: {
      metric_type: metricType = 'sum',
      hll,
      is_count
    }
  } = column;
  const custom_column_lower = custom_column.toLowerCase();
  let alias = `f_${metricType}_${custom_column_lower}`;
  if (hll) {
    alias = `f_hll(${custom_column_lower}.agg0,0.0001)`;
  } else if (is_count && custom_column_lower === 'i_count' && metricType === 'sum') {
    alias = 'trautocount';
  }
  return alias;
};
exports.getAppProtocolAlias = getAppProtocolAlias;
const assignDimensionToDirection = (colKey, label, direction, container) => {
  if (direction === 'source') {
    container.src[colKey] = label.replace(/source\s/i, '');
  } else if (direction === 'destination') {
    container.dst[colKey] = label.replace(/destination\s/i, '');
  } else {
    container.other[colKey] = label;
  }
};
exports.assignDimensionToDirection = assignDimensionToDirection;
function getInverseAndDirection(col_name) {
  let inverse = null;
  let direction = null;
  if (_customDimensionConstants.IN_REGEXP.test(col_name)) {
    inverse = col_name.replace(_customDimensionConstants.IN_REGEXP, '_out$1');
    direction = 'src';
  } else if (_customDimensionConstants.OUT_REGEXP.test(col_name)) {
    inverse = col_name.replace(_customDimensionConstants.OUT_REGEXP, '_in$1');
    direction = 'dst';
  } else if (_customDimensionConstants.TO_REGEXP.test(col_name)) {
    inverse = col_name.replace(_customDimensionConstants.TO_REGEXP, '_from$1');
    direction = 'src';
  } else if (_customDimensionConstants.FROM_REGEXP.test(col_name)) {
    inverse = col_name.replace(_customDimensionConstants.FROM_REGEXP, '_to$1');
    direction = 'dst';
  } else if (_customDimensionConstants.SRC_REGEXP.test(col_name)) {
    inverse = col_name.replace(_customDimensionConstants.SRC_REGEXP, '_dst$1');
    direction = 'src';
  } else if (_customDimensionConstants.DST_REGEXP.test(col_name)) {
    inverse = col_name.replace(_customDimensionConstants.DST_REGEXP, '_src$1');
    direction = 'dst';
  } else if (col_name.includes('Src')) {
    inverse = col_name.replace('Src', 'Dst');
    direction = 'src';
  } else if (col_name.includes('Dst')) {
    inverse = col_name.replace('Dst', 'Src');
    direction = 'dst';
  }
  return {
    inverse,
    direction
  };
}